import React from 'react';

import './index.module.less';

import HalfScreenInfoModal from '@components/HalfScreenInfoModal';
import CommonBtn from '@components/CommonBtn';
import { GuardItem } from '@apis/gloabal';
import ConfirmModal from '@views/components/ConfirmModal';
import Http from '@helpers/Http';
import { Api } from '@apis/client';
import * as Cache from '../../../../../../app/helpers/Cache';
import FridayService from '@services/friday';

interface IProps {
  item: GuardItem;
  onClose: () => void;
  onDeleteSuccess: (uid: string) => void;
  onEditClick: (uid: string) => void;
}

const EditAreaMenu = (props: IProps) => {
  const onEditClick = () => {
    FridayService.addEvent('security_guard_edit_guard_area_click');
    props.onClose && props.onClose();
    Cache.save(props.item.uid, props.item);
    props.onEditClick && props.onEditClick(props.item.uid);
  }

  const onDeleteClick = () => {
    FridayService.addEvent('security_guard_delete_guard_area_click');
    props.onClose && props.onClose();
    ConfirmModal.show({
      title: '确认删除？',
      showCancelBtn: true,
      text: '删除后，将无法恢复。',
      cancelBtnText: '取 消',
      confirmBtnText: '删 除',
      onConfirm: deleteGuardArea
    });
  }

  const deleteGuardArea = async () => {
    props.onClose && props.onClose();
    const result = await Http.post(Api.DeleteGuardArea,
      { uid: props.item.uid }
    ).catch(e => {
      // nothing
    });
    if(result) {
      props.onDeleteSuccess && props.onDeleteSuccess(props.item.uid);
    }
  }

  return (
    <HalfScreenInfoModal
      height="4.8rem"
      onClose={ props.onClose }
      hideCloseBtn={ true }
    >
      <div className='flex' styleName='menu-container'>
        <div className='flex' styleName='menu-item' onClick={onEditClick}>修改守护区域</div>
        <div className='flex' styleName='menu-item' style={{color: '#E52E3D' }} onClick={onDeleteClick}>删除</div>
      </div>
      <CommonBtn
        type="fixed"
        btnText="取 消"
        onConfirm={ props.onClose }
        style={{ background: '#F2F4F7', color: '#55585C', fontSize: '.32rem', marginBottom: '.48rem' }}
      />
    </HalfScreenInfoModal>
  )
}

export default EditAreaMenu;